module.exports = __webpack_public_path__ + "img/y-title-1.ec78e295.png";